



































































































































































import { getCountry, getCountryName } from '@/utils';
import {Action, Mutation, State, Getter} from 'vuex-class';
import {Component, Vue} from 'vue-property-decorator';
import {
  FETCH_USER_LIST,
  CREATE_USER_LIST,
  GET_USER_LIST,
  UPDATE_CURRENT_USER_TAB,
  GET_CURRENT_USER_TAB,
  UPDATE_SELECTED_USER,
  FETCH_USER_PROFILES,
  UPDATE_SELECTED_USER_PROFILES,
  FETCH_USER_PROFILE_FUNCTIONALITIES_GROUPED,
  UPDATE_USER_FUNCTIONALITY_RESTRICTIONS,
  FETCH_CLIENT_CONTRACTS,
  GET_SELECTED_USER,
  FETCH_USER_BONDS_LIST,
  UPDATE_USER_BONDS,
  FETCH_LOCALE_TYPES_LIST,
  FETCH_USER_REPORT, FETCH_ROLE_CLASSIFICATIONS,
} from '@/modules/user/store';

import {FETCH_USER_TYPE_LIST} from '@/modules/user-type/store';

import {IProfile} from '@/modules/profile/models';
import {IUser} from '@/modules/user/models';
import {RootState} from '@/store';
import {nameof} from 'ts-simple-nameof';
import {userTabs} from '@/modules/user/models/Tabs';
import {MessageService} from '@/services/messageService';
import {IBond} from '@/models/Bond';
import {AxiosResponse} from 'axios';

@Component
export default class extends Vue {
  public isLoading: boolean = false;
  public generatingFile: boolean = false;
  public showRegisterForm: boolean = false;
  public showBondTab: boolean = false;
  public showBondRegisterTab: boolean = false;
  public state = {};
  public tabs = userTabs.tabs;
  public search: string = '';
  public selected: any[] = [];
  public isOnlyActive = true;
  public headersStores: any[] = [
    {text: 'Tipo Usuário', value: 'usertype.usertypename'},
    {text: 'Nome', value: 'fullusername'},
    {text: 'E-mail', value: 'email'},
    {text: 'Status', sortable: false, value: 'isactive'},
  ];

  public pagination: any = {
    sortBy: 'fullusername',
    descending: false,
  };

  @Getter(GET_SELECTED_USER)
  public userSelected: IUser;

  @Getter(GET_USER_LIST)
  public users: IUser[];

  @Getter(GET_CURRENT_USER_TAB)
  public currentTab: string;

  @Action(FETCH_USER_LIST)
  private getAllUsers: any;

  @Action(CREATE_USER_LIST)
  private setAllusers: any;

  @Action(FETCH_USER_TYPE_LIST)
  private getAllUserTypes: any;

  @Action(UPDATE_SELECTED_USER)
  private setSelectedUser: any;

  @Action(UPDATE_CURRENT_USER_TAB)
  private setUserCurrentTab: any;

  @Action(FETCH_USER_PROFILES)
  private getUserProfiles: any;

  @Action(UPDATE_SELECTED_USER_PROFILES)
  private setUserProfiles: any;

  @Action(FETCH_USER_PROFILE_FUNCTIONALITIES_GROUPED)
  private getProfileFunctionalitiesGrouped: any;

  @Action(FETCH_CLIENT_CONTRACTS)
  private getClientContracts: any;

  @Action(FETCH_USER_BONDS_LIST)
  private getUserBonds: any;

  @Action(UPDATE_USER_BONDS)
  private setUserBonds: any;

  @Action(FETCH_LOCALE_TYPES_LIST)
  private getLocaleTypes: any;

  @Action(FETCH_USER_REPORT)
  private exportUsersReport: any;

  public created() {
    this.isLoading = true;
    this.getAllUsers(this.isOnlyActive)
      .then((ret: any) => {
        this.setAllusers(ret.data);
      })
      .finally(() => {
        this.isLoading = false;
      });

    this.getAllUserTypes();
    this.getClientContracts();
  }

  public onFilter() {
    this.isLoading = true;

    this.getAllUsers(this.isOnlyActive)
      .then((ret: any) => {
        this.setAllusers(ret.data);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  public habilitarCadastro() {
    this.setSelectedUser({isactive: true});
    this.setUserBonds([]);
    this.setUserCurrentTab(userTabs.tabs.registertab);
  }

  public selectUser(selectedUser: IUser) {
    const getUserProfileAndBonds: [Promise<any>, Promise<any>, Promise<any>] = [
      this.getUserProfiles(selectedUser.id),
      this.getUserBonds(selectedUser.id),
      this.getLocaleTypes(selectedUser.cdclicon),
    ];

    Promise.all(getUserProfileAndBonds).then((results: any[]) => {
      const userProfiles: IProfile[] = results[0].data;
      const userBonds: IBond[] = results[1].data;

      this.setSelectedUser(selectedUser);
      this.setUserProfiles(userProfiles);
      this.setUserBonds(userBonds);
      this.showBondTab = true;
      this.showBondRegisterTab = true;
      this.setUserCurrentTab(userTabs.tabs.registertab);
    });
  }

  public exportUsers() {
    const country = getCountry();
    this.generatingFile = true;
    this.exportUsersReport().then((response: AxiosResponse<any>) => {
      const url = window.URL.createObjectURL(
        new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
      );
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', `${getCountryName(country)}_Usuarios_Neogig.xlsx`);
      document.body.appendChild(link);
      link.click();
    }).catch((err: any) => console.log(err))
      .finally(() => {
        this.generatingFile = false;
      });
  }

  public setTab(selectedTab: string) {
    this.setUserCurrentTab(selectedTab);
  }

  public getBadgeColor(icatv: boolean) {
    return icatv ? 'teal' : 'red';
  }
}
